import type { FluxErrorEntityErrorCodes } from '../types.js';

export const TeamErrorCodes = {
  TeamDeleteHasAssignedCards: {
    code: 'team/delete-has-assigned-cards',
    explanation:
      'O time que você está tentando excluir possui cards atribuídos, remova o time dos cards antes de excluí-lo.',
    localizations: {},
    message: 'Time não pode ser excluído, pois possui cards atribuídos.',
  },
  TeamNotFound: {
    code: 'team/not-found',
    explanation: 'O time que você está tentando acessar não foi encontrado.',
    localizations: {},
    message: 'Time não encontrado.',
  },
} satisfies FluxErrorEntityErrorCodes<'team'>;

export const TeamsMembersErrorCodes = {
  TeamMemberAlreadyExists: {
    code: 'team-member/already-exists',
    explanation: 'O membro do time que você está tentando adicionar já existe.',
    localizations: {},
    message: 'Membro do time já existe.',
  },
  TeamMemberNotFound: {
    code: 'team-member/not-found',
    explanation: 'O membro do time que você está tentando acessar não foi encontrado.',
    localizations: {},
    message: 'Membro do time não encontrado.',
  },
  TeamMemberRemoveLastMember: {
    code: 'team-member/remove-last-member',
    explanation:
      'O time deve ter pelo menos um membro, por esse motivo não é possível remover o último membro do time. Caso deseje, exclua o time.',
    localizations: {},
    message: 'Não é possível remover o último membro do time.',
  },
} satisfies FluxErrorEntityErrorCodes<'team-member'>;
